<mat-toolbar>
    <mat-toolbar-row class="mat-elevation-z2 main-toolbar">
        <button class="nav-toggler" mat-icon-button (click)="onToggleSidenav()">
            <mat-icon>menu</mat-icon>
        </button>
        <h1 class="page-name">{{pageTitle}}</h1>
        <ul class="menu-links">
            <li>
                <app-language-selector ></app-language-selector>
            </li>
        </ul>
    </mat-toolbar-row>
</mat-toolbar>
